<script>
	import { onMount } from 'svelte'
	import { adminUpdateShopEntry } from '../AdminModule.svelte'
	import { urlAdmin } from '../../../library/scripts/Setup.svelte'
	import TwoCols from '../../../library/columLayouts/TwoCols.svelte'
	import ShopPreview from './ShopPreview.svelte'
	import ShopEntry from './ShopEntry.svelte'

	//holds the menu objects
	let items = []

	//load the menu from db
	const fetch_products_from_db = async () => {
		const fetchItems = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'get_shop_products',
			}),
		})

		const dataResponse = await fetchItems.json()

		if (dataResponse.fetch === 0 || !dataResponse.fetch) {
			adminUpdateShopEntry.set('[]')
			sessionStorage.setItem('shop', '[]')
			return
		}

		dataResponse.fetch.forEach((item) => {
			let tmpItem = {
				id: item[0],
				category: item[1],
				name: item[2],
				properties: item[3],
				descshort: item[4],
				desclong: item[5],
				image: item[6],
				price: item[7],
				stock: item[8],
				currency: item[9],
			}

			//add the item at the beginning of the array menu
			items.push(tmpItem)
		})

		adminUpdateShopEntry.set(JSON.stringify(items))
		sessionStorage.setItem('shop', JSON.stringify(items))
	}
	onMount(() => {
		fetch_products_from_db()
	})
</script>

<TwoCols column="290px" alignVertical="start">
	<div slot="column1">
		<ShopEntry />
	</div>

	<div slot="column2">
		<ShopPreview />
	</div>
</TwoCols>
